<div class="signup-container">
  <section>
    <div class="left-side">
      <div class="left-side-body">
        <a href="/">
          <img src="assets/images/svg/logo.svg" alt="Logo" />
        </a>
        <div class="title">
          {{ 'We’re upgrading our security system.' | translate }}
        </div>
        <div class="sub-title">
          {{ 'Get excited to never enter your username again.' | translate }}
        </div>
        <br />
        <div
          class="description"
          *ngIf="
            ((form.get('email')?.invalid && form.get('email')?.touched) ||
              (form.get('password')?.invalid && form.get('password')?.touched) ||
              (form.get('repassword')?.invalid && form.get('repassword')?.touched)) &&
            this.signUpStatus === Status.NEW
          "
        >
          {{ 'We have new requirements for passwords so check those out here:' | translate }}
        </div>
        <div class="errors left">
          <mat-error class="error-line" *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched">
            <mat-icon color="warn" fontIcon="error_outline" class="error-icon">error_outline</mat-icon>
            {{ 'Email is required' | translate }}
          </mat-error>
          <mat-error class="error-line" *ngIf="form.get('email')?.invalid && form.get('email')?.touched && !form.get('email')?.hasError('required')">
            <mat-icon color="warn" fontIcon="error_outline" class="error-icon">error_outline</mat-icon>
            {{ 'Email is invalid' | translate }}
          </mat-error>
          <mat-error class="error-line" *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched">
            <mat-icon color="warn" fontIcon="error_outline" class="error-icon">error_outline</mat-icon>
            {{ 'New password is required' | translate }}
          </mat-error>
          <mat-error class="error-line" *ngIf="form.get('repassword')?.hasError('required') && form.get('repassword')?.touched">
            <mat-icon color="warn" fontIcon="error_outline" class="error-icon">error_outline</mat-icon>
            {{ 'Re-enter password is required' | translate }}
          </mat-error>
          <mat-error class="error-line" *ngIf="form.get('repassword')?.hasError('passwordMismatch') && form.get('repassword')?.touched">
            <mat-icon color="warn" fontIcon="error_outline" class="error-icon">error_outline</mat-icon>
            {{ 'Re-enter password does not match' | translate }}
          </mat-error>
        </div>
      </div>
    </div>
    <div class="right-side">
      <form *ngIf="this.signUpStatus === Status.NEW" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="signup-form">
          <div class="form-description">
            {{ 'Please enter your email address and create a new password' | translate }}
          </div>
          <div class="flex flex-column left w-full gap-30">
            <mat-form-field class="mat-form-field" appearance="outline">
              <mat-label>{{ 'Email' | translate }}</mat-label>
              <input id="email" formControlName="email" type="email" matInput required placeholder="{{ 'Email' | translate }}" />
              <mat-icon matSuffix class="material-icons-outlined">email</mat-icon>
            </mat-form-field>
            <mat-form-field class="mat-form-field" appearance="outline">
              <mat-label>{{ 'New password' | translate }}</mat-label>
              <input
                id="password"
                formControlName="password"
                matInput
                [type]="showPassword() ? 'text' : 'password'"
                required
                placeholder="{{ 'New password' | translate }}"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="togglePassword($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="showPassword()"
                class="btn-toggle-password"
                tabindex="-1"
              >
                <mat-icon class="material-icons-outlined">{{ showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field class="mat-form-field" appearance="outline">
              <mat-label>{{ 'Re-enter password' | translate }}</mat-label>
              <input
                id="repassword"
                formControlName="repassword"
                matInput
                [type]="showRePassword() ? 'text' : 'password'"
                required
                placeholder="{{ 'Re-enter password' | translate }}"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="toggleRePassword($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="showRePassword()"
                class="btn-toggle-password"
                tabindex="-1"
              >
                <mat-icon class="material-icons-outlined">{{ showRePassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div class="pwd-validation">
          <p class="pwd-title">
            {{ 'Password must contain:' | translate }}
          </p>
          <ul>
            <li>
              <img [src]="getPwdStrengthIcon(hasMinLengthPwd())" alt="Check/Uncheck icon" />
              <span [ngClass]="getPwdStrengthClass(hasMinLengthPwd())">
                {{ 'At least 10 characters' | translate }}
              </span>
            </li>
            <li>
              <img [src]="getPwdStrengthIcon(hasLowercasePwd())" alt="Check/Uncheck icon" />
              <span [ngClass]="getPwdStrengthClass(hasLowercasePwd())">
                {{ 'At least 1 lowercase character' | translate }}
              </span>
            </li>
            <li>
              <img [src]="getPwdStrengthIcon(hasUppercasePwd())" alt="Check/Uncheck icon" />
              <span [ngClass]="getPwdStrengthClass(hasUppercasePwd())">
                {{ 'At least 1 uppercase character' | translate }}
              </span>
            </li>
            <li>
              <img [src]="getPwdStrengthIcon(hasNumberAndSpecial())" alt="Check/Uncheck icon" />
              <span [ngClass]="getPwdStrengthClass(hasNumberAndSpecial())">
                {{ 'At least 1 number and 1 special (&#64;, #, $,...) character' | translate }}
              </span>
            </li>
          </ul>
        </div>
        <div>
          <button type="submit" mat-button [disabled]="!form.valid" class="btn-submit">
            {{ 'button.Submit' | translate }}
          </button>
        </div>
      </form>
      <app-migration-in-progress *ngIf="this.signUpStatus === Status.IN_PROGRESS" />
      <app-migration-success *ngIf="this.signUpStatus === Status.SUCCESS" [email]="this.email" />
      <app-migration-fail *ngIf="this.signUpStatus === Status.FAIL" [error]="this.error" (handleTryAgain)="handleTryAgain($event)" />
    </div>
  </section>
</div>
